module.exports = __webpack_public_path__ + "static/img/ruzhu-04.9cc5bd2c.png";